module.exports = __webpack_public_path__ + "img/wordmark-orange.95f9bb14.svg";